// design/035 — public page behind the "Unsubscribe" link in new course /
// practice emails (/unsubscribe?t=…). No sign-in. Opening the page only
// checks the link; the person confirms with the button, so mail scanners that
// open links don't unsubscribe anyone.
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../lib/api';

export default function UnsubscribePage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('t') || '';
  const [state, setState] = useState('checking'); // checking | ready | done | invalid | error
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState('invalid'); return; }
    api.unsubscribeCheck(token)
      .then((r) => setState(r?.valid ? 'ready' : 'invalid'))
      .catch(() => setState('invalid'));
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    try { await api.unsubscribe(token); setState('done'); }
    catch { setState('error'); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ maxWidth: 520, margin: '0 auto', padding: '48px 20px', lineHeight: 1.6, color: 'var(--ink, #111827)' }}>
      <a onClick={() => navigate('/')} style={{ cursor: 'pointer', fontSize: '0.875rem' }}>← Compassion Practice</a>
      <h1 style={{ marginBottom: 12 }}>Email preferences</h1>
      {state === 'checking' && <p>Checking your link…</p>}
      {state === 'ready' && (
        <>
          <p>Stop getting emails about new courses, practices, events and groups?</p>
          <button className="btn btn-primary" disabled={busy} onClick={confirm}>
            {busy ? 'Unsubscribing…' : 'Unsubscribe'}
          </button>
        </>
      )}
      {state === 'done' && (
        <>
          <p><b>You're unsubscribed.</b> You won't get emails about new courses, practices, events and groups.</p>
          <p style={{ color: 'var(--muted, #6b7280)' }}>
            You'll still get emails about your account, purchases, invites and the programs you've joined.
            To turn them back on, sign in and go to Profile → Email preferences.
          </p>
        </>
      )}
      {state === 'invalid' && <p>This unsubscribe link isn't valid. Sign in and use Profile → Email preferences instead.</p>}
      {state === 'error' && <p>Something went wrong. Please try again, or use Profile → Email preferences after signing in.</p>}
    </div>
  );
}
